import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { X, Check } from 'lucide-react';
import { PROFESSIONAL_TYPES } from './professionalConstants';

export default function ProfessionalForm({
  formData,
  setFormData,
  isEditing,
  onSubmit,
  onCancel,
}) {
  return (
    <Card className="bg-slate-800 border-slate-700">
      <CardHeader>
        <CardTitle className="text-white flex items-center justify-between">
          {isEditing ? 'Edit Professional' : 'Add New Professional'}
          <Button variant="ghost" size="sm" onClick={onCancel}>
            <X className="h-4 w-4" />
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Name *</label>
              <Input
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="bg-slate-900 border-slate-600"
                data-testid="professional-name-input"
              />
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Type *</label>
              <Select
                value={formData.professional_type}
                onValueChange={(val) => setFormData({ ...formData, professional_type: val })}
              >
                <SelectTrigger className="bg-slate-900 border-slate-600" data-testid="professional-type-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {PROFESSIONAL_TYPES.map(type => (
                    <SelectItem key={type.value} value={type.value}>{type.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Company</label>
              <Input
                value={formData.company}
                onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                className="bg-slate-900 border-slate-600"
              />
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Location</label>
              <Input
                value={formData.location}
                onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                placeholder="City, State"
                className="bg-slate-900 border-slate-600"
              />
            </div>
            <div className="md:col-span-2">
              <label className="text-sm text-slate-400 mb-1 block">Bio *</label>
              <textarea
                value={formData.bio}
                onChange={(e) => setFormData({ ...formData, bio: e.target.value })}
                required
                rows={3}
                className="w-full bg-slate-900 border border-slate-600 rounded-md p-2 text-white"
                data-testid="professional-bio-input"
              />
            </div>
            <div className="md:col-span-2">
              <label className="text-sm text-slate-400 mb-1 block">Specialties (comma-separated)</label>
              <Input
                value={formData.specialties}
                onChange={(e) => setFormData({ ...formData, specialties: e.target.value })}
                placeholder="Tax Planning, Estate Planning, Investment"
                className="bg-slate-900 border-slate-600"
              />
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Email</label>
              <Input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="bg-slate-900 border-slate-600"
              />
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Phone</label>
              <Input
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="bg-slate-900 border-slate-600"
              />
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Website</label>
              <Input
                value={formData.website}
                onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                className="bg-slate-900 border-slate-600"
              />
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1 block">Member Discount</label>
              <Input
                value={formData.member_discount}
                onChange={(e) => setFormData({ ...formData, member_discount: e.target.value })}
                placeholder="e.g., 15% off initial consultation"
                className="bg-slate-900 border-slate-600"
              />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.is_featured}
                onChange={(e) => setFormData({ ...formData, is_featured: e.target.checked })}
                className="rounded"
              />
              <label className="text-sm text-slate-400">Featured Professional</label>
            </div>
          </div>
          <div className="flex gap-2 pt-4">
            <Button type="submit" className="bg-amber-600 hover:bg-amber-700" data-testid="save-professional-btn">
              <Check className="h-4 w-4 mr-2" />
              {isEditing ? 'Update' : 'Create'} Professional
            </Button>
            <Button type="button" variant="outline" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
